import { useState, useLayoutEffect, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "@mui/material";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

export const useScreenSize = (): {
  isMedium: boolean;
  isMobile: boolean;
  isLarge: boolean;
} => {
  const theme = useTheme();
  const [isClient, setIsClient] = useState(false);

  const isMobile = useMediaQuery({
    maxWidth: theme.breakpoints.values.sm - 0.05,
  });

  const isMedium = useMediaQuery({
    minWidth: theme.breakpoints.values.md,
  });

  const isLarge = useMediaQuery({
    minWidth: theme.breakpoints.values.lg,
  });

  useIsomorphicLayoutEffect(() => {
    if (typeof window !== "undefined") setIsClient(true);
  }, []);

  return {
    isMedium: isClient ? isMedium : false,
    isMobile: isClient ? isMobile : true,
    isLarge: isClient ? isLarge : false,
  };
};
